module.exports = __webpack_public_path__ + "img/22.9ecae47f.png";